import { render, staticRenderFns } from "./address-searchbar.vue?vue&type=template&id=1f4acb83&"
import script from "./address-searchbar.vue?vue&type=script&lang=js&"
export * from "./address-searchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports